module.exports = "<app-taxinfo></app-taxinfo>"